// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jkTj","footer":"styles_footer__eRGwS"};